/* OXXRING v2 WP6: pack picker + one-click add on catalogue rows (snippets/oxx-ic-product-row.liquid, qa: true).
   Works on server-rendered rows (collections) and rows inserted later (quick-finder results), via delegation.
   Without JS the form still posts to /cart/add. The router decided on the server which rows get a form. */
(function () {
  'use strict';
  if (window.OXXICQA) return;
  window.OXXICQA = true;

  function fmt(cents, cur) { return cur + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function perPiece(cents, qty, cur) {
    var pp = cents / qty; // cents per piece
    if (pp < 1) return '< ' + cur + '0.01';
    if (pp < 10) return cur + (pp / 100).toFixed(3);
    return fmt(Math.round(pp), cur);
  }
  function track(name, detail) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, detail || {})); }

  // Persistent, accessible confirmation keeps the cart destination visible even when the header is off-screen.
  function showCartToast() {
    var toast = document.querySelector('[data-oxx-cart-toast]');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    // Shopify's preview toolbar iframe spans the viewport; reserve its visible bottom bar (64px) when present.
    var previewBar = document.querySelector('#PBarNextFrame, #preview-bar-iframe, iframe[src*="preview-bar"]');
    var previewBarHeight = previewBar ? 64 : 0;
    var bottomOffset = 12 + (previewBarHeight > 0 ? previewBarHeight : 0);
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-oxx-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.style.cssText = 'position:fixed;left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom, 0px));z-index:2147483000;display:flex;align-items:center;gap:12px;max-width:620px;margin:0 auto;padding:12px 14px;background:#0b1b2e;color:#fff;border:1px solid rgba(255,255,255,.16);border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.24);font-family:inherit;font-size:14px;line-height:1.4;';
      var message = document.createElement('span');
      message.setAttribute('data-oxx-cart-toast-message', '');
      message.textContent = 'Added to cart';
      message.style.cssText = 'flex:1;min-width:0;';
      var link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'View cart';
      link.setAttribute('aria-label', 'View cart and check out');
      link.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-height:38px;padding:0 13px;border-radius:8px;background:#ff6b13;color:#0b1b2e;font-weight:700;text-decoration:none;white-space:nowrap;flex:none;';
      var close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('aria-label', 'Dismiss cart confirmation');
      close.textContent = '×';
      close.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:30px;height:38px;padding:0;border:0;background:transparent;color:#fff;font-size:24px;line-height:1;cursor:pointer;flex:none;';
      close.addEventListener('click', function () { if (toast.parentNode) toast.parentNode.removeChild(toast); });
      toast.append(message, link, close);
      document.body.appendChild(toast);
    } else {
      var msg = toast.querySelector('[data-oxx-cart-toast-message]');
      if (msg) msg.textContent = 'Added to cart';
      var a = toast.querySelector('a');
      if (a) a.href = cartUrl;
    }
    toast.style.bottom = 'calc(' + bottomOffset + 'px + env(safe-area-inset-bottom, 0px))';
  }

  function paint(form) {
    var sel = form.querySelector('[data-ic-qa-pack]');
    if (!sel) return;
    var o = sel.options[sel.selectedIndex];
    var qty = parseInt(o.getAttribute('data-qty'), 10) || 1, cents = parseInt(o.getAttribute('data-price'), 10) || 0;
    var cur = form.getAttribute('data-cur') || '$', unit1 = form.getAttribute('data-unit1') || 'pc';
    var row = form.closest('tr');
    if (row) {
      var t = row.querySelector('[data-ic-row-total]'); if (t) t.textContent = o.getAttribute('data-money') || fmt(cents, cur);
      var u = row.querySelector('[data-ic-row-unit]'); if (u) u.textContent = '/ ' + (qty === 1 ? unit1 : qty + ' pcs');
      var p = row.querySelector('[data-ic-row-pp]'); if (p) { p.hidden = qty === 1; p.textContent = perPiece(cents, qty, cur) + ' / pc'; }
    }
    var l = form.querySelector('[data-ic-qa-label]');
    if (l) l.textContent = qty === 1 ? (unit1 === 'pc' ? 'Add 1 pc' : 'Add to cart') : 'Add ' + qty + ' pcs';
  }

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-ic-qa-pack]');
    if (s) paint(s.closest('[data-ic-qa]'));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ic-qa]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-ic-qa-add]'), label = form.querySelector('[data-ic-qa-label]');
    if (btn.disabled) return;
    var id = (form.querySelector('[name="id"]') || {}).value;
    var before = label ? label.textContent : '';
    btn.disabled = true; btn.classList.add('is-busy');
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(base + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        if (label) label.textContent = 'Added';
        showCartToast();
        document.dispatchEvent(new CustomEvent('oxx:cart:changed'));
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-ic-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); });
        }).catch(function () {});
        var row = form.closest('tr');
        track('oxx_quick_add', { handle: row ? row.getAttribute('data-handle') : '', variant_id: id, source: form.closest('[data-ic-qf-results]') ? 'quickfind' : 'listing' });
        setTimeout(function () { btn.classList.remove('is-done'); btn.disabled = false; if (label) label.textContent = before; }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy'); btn.disabled = false;
        if (label) label.textContent = before;
        var m = form.querySelector('.ic-qa__msg');
        if (!m) { m = document.createElement('p'); m.className = 'ic-qa__msg'; m.setAttribute('role', 'alert'); form.appendChild(m); }
        m.textContent = err.message || 'Could not add to cart. Open the product to choose a pack.';
      });
  }, true);
})();
